<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
            title="Restrictions Report"
            icon="fas fa-list"
            buttonLabel="EXPORT CSV"
            buttonIcon="fas fa-plus"
            (buttonClick)="export()">
          </card-section-header>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>From</label>
                <p-calendar class="form-control" [(ngModel)]="fromDate" (ngModelChange)="onFromDateChange($event)" dateFormat="dd/mm/yy"></p-calendar>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>To</label>
                <p-calendar class="form-control" [(ngModel)]="toDate" (ngModelChange)="onToDateChange($event)" dateFormat="dd/mm/yy"></p-calendar>
              </div>
            </div>
            <div class="col-md-4" *ngIf="sitesArray.length">
              <div class="form-group">
                <label>Site</label>
                <p-dropdown
                    class="form-control"
                    [(ngModel)]="selectedSite"
                    (ngModelChange)="onSelectedSiteChange($event)"
                    [options]="sitesArray"
                    optionLabel="label"
                    defaultLabel="Select Site"
                    filter="true"
                    [style]="{'width':'100%'}">
                </p-dropdown>
              </div>
            </div>
            <div class="col-md-4" *ngIf="sitesArray.length">
              <div class="form-group">
                <label>Restriction Category</label>
                <p-dropdown
                    class="form-control"
                    [(ngModel)]="restrictionType"
                    (ngModelChange)="onRestrictionTypeChange($event)"
                    [options]="types"
                    optionLabel="label"
                    defaultLabel="Site & Asset"
                    filter="true"
                    [style]="{'width':'100%'}">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="restrictions" selectionMode="single" [autoLayout]="true">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Restriction Category</th>
                    <th>Active</th>
                    <th>Site</th>
                    <th>Asset</th>
                    <th>Type</th>
                    <th style="width:30%">Description</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Last Modified By</th>
                    <th>Last Modified Date</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-restriction>
                  <tr [pSelectableRow]="restriction">
                    <td>{{ restriction.restrictionCategory }}</td>
                    <td class="table-cell-centered">
                      <span *ngIf="restriction.active"><i class="fas fa-check-circle success"></i></span>
                      <span *ngIf="!restriction.active"><i class="fas fa-times-circle danger"></i></span>
                    </td>
                    <td>{{ restriction.siteName }}</td>
                    <td>{{ restriction.assetName }}</td>
                    <td>
                      <span *ngIf="restriction.restrictionType === 'OPERATIONAL'" class="badge badge-pill badge-warning">Operational</span>
                      <span *ngIf="restriction.restrictionType === 'HEALTH_AND_SAFETY'" class="badge badge-pill badge-danger">Health & Safety</span>
                      <span *ngIf="restriction.restrictionType === 'GENERAL'" class="badge badge-pill badge-primary">General</span>
                    </td>
                    <td>{{ restriction.description }}</td>
                    <td>{{ restriction.createdBy }}</td>
                    <td><date-friendly [value]="restriction.createdDate"></date-friendly></td>
                    <td>{{ restriction.lastModifiedBy }}</td>
                    <td><date-friendly [value]="restriction.lastModifiedDate"></date-friendly></td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="10">
                      No Restrictions found for these dates
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
